module.exports = __webpack_public_path__ + "static/downloable/guia-solicitud-de-pago-de-herencia.245de66.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/guias/guia-solicitud-de-pago-de-herencia.pdf
// module id = n6Sv
// module chunks = 1